module.exports = __webpack_public_path__ + "static/wafer-cassette-677979ec1c120ba0a2585ccdefa300e7.png";